import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createSubCategory: [],
  loading: false,
  error: null,
};

const createSubCategorySlice = createSlice({
  name: "createSubCategory",
  initialState,
  reducers: {
    fetchCreateSubCategoryRequest: (state) => {
      state.loading = true;
    },

    fetchCreateSubCategorySuccess: (state, action) => {
      state.loading = false;
      state.createSubCategory = action.payload;
    },

    fetchCreateSubCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCreateSubCategoryRequest,
  fetchCreateSubCategorySuccess,
  fetchCreateSubCategoryFailure,
} = createSubCategorySlice.actions;

export default createSubCategorySlice.reducer;
